import { useAppSelector } from "@quest/hooks";
import { appConfig } from "@quest/appConfig";

interface IProps {
  handleClick?: () => void;
}

function SchoolLogo({ handleClick }: IProps) {
  const { logo } = useAppSelector((state) => state.tenant);

  const logoUrl = `${appConfig.apiUrl}/${logo}`;
  return (
    <>
      <div
        className="w-[80px] h-[80px] pl-4  cursor-pointer sticky top-[2.5rem]"
        onClick={handleClick}
      >
        <img
          src={logoUrl}
          alt="Logo"
          className="w-full h-full object-contain"
        />
      </div>
    </>
  );
}

export default SchoolLogo;
